import React, { useRef, useEffect } from "react";
import Moment from "react-moment";

const Message = ({ msg, user1 }) => {
  const scrollRef = useRef();

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msg]);

  const timestamp = msg.createdAt?.toDate ? msg.createdAt.toDate() : null;

  return (
    <div
      className="msg_wrapper"
      ref={scrollRef}
      style={{
        margin: 0,
        padding: 0,
        display: "flex",
        justifyContent: msg.sender === user1 ? "flex-end" : "flex-start",
      }}
    >
      <div
        style={{
          padding: "8px",
          margin: "4px",
          maxWidth: "60%",
          borderRadius: "8px",
          backgroundColor: msg.sender === user1 ? "#6c757d" : "#ccc",
          color: msg.sender === user1 ? "#fff" : "#000",
        }}
      >
        <div>{msg.text}</div>
        <small>
          {timestamp ? <Moment fromNow>{timestamp}</Moment> : "..."}
        </small>
      </div>
    </div>
  );
};

export default Message;
